import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const serviceVisitTypesBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Inicio', to: '/' },
  { label: 'Sistema de envíos', to: '/business' },
  { label: 'Red logística', to: '/business/logistics-network' },
  {
    label: 'Tipos de visita',
    onClick: () => navigate('/business/service-visit-types'),
  },
];

export const createServiceVisitTypeBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => serviceVisitTypesBreadcrumbs(navigate);

export const editServiceVisitTypeBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => serviceVisitTypesBreadcrumbs(navigate);
